import {eq} from '@shared/helpers/lang'

import {ProcessingStep, ProcessingStepType} from '../constants'
import {Checkout, CheckoutCourse, Course, CourseType, Family, FamilyCourse, OrderRequest} from '../interfaces'

/** 주문형 주문서 코스 여부 (가맹점, 예블카, 스스 ) */
export function isCheckout(course: CourseType): course is CheckoutCourse {
    const list: Array<CourseType> = [Course.MALL, Course.EASY_BOOKING, Course.SELLER]
    return list.includes(course)
}
/** 주문형 주문서 코스 여부 (패밀리) */
export function isPayNext(course: CourseType): course is FamilyCourse {
    const list: Array<CourseType> = [Course.FAMILY]
    return list.includes(course)
}

/** 코스 정보 */
export function getCourseInfo(course: CourseType) {
    const eqCourse = eq(course)
    return {
        isMall: eqCourse(Course.MALL),
        isEasyBooking: eqCourse(Course.EASY_BOOKING),
        isSeller: eqCourse(Course.SELLER),
        isFamily: eqCourse(Course.FAMILY),
    }
}

export function isCheckoutCourse(order: OrderRequest): order is Checkout {
    return isCheckout(order.course)
}

/** 나중에 결제 코스 여부 */
export function isPayNextCourse(order: OrderRequest): order is Family {
    return order.course === Course.FAMILY
}

export function getCourse(course: CourseType): {
    steps: ProcessingStepType[]
    firstStep?: ProcessingStepType
} {
    let steps: ProcessingStepType[] = []
    if (isCheckout(course)) {
        steps = [
            ProcessingStep.PREPARE,
            ProcessingStep.PROCESSING,
            ProcessingStep.VAN_CHECK,
            ProcessingStep.FDS_CHECK,
            ProcessingStep.APPLYING,
        ]
    }
    if (isPayNext(course)) {
        steps = [ProcessingStep.PREPARE, ProcessingStep.FDS_CHECK, ProcessingStep.APPLYING]
    }

    return {
        steps,
        firstStep: steps[0],
    }
}
